import { request, upload } from './request';
import request_body from './request_body';
// import * as echarts from "echarts";


export default { 
	request_body,
	async login(data) {
		// request_body.logout();
		// console.log(data)
		let rs = await request("/login/auth", data);
		if (rs.code == 200) {
			request_body.login(rs);
		}
		return rs;
	},
	async loginOut() {
		request_body.logout();
	},
	async getIndex(){
		return request("/main/getIndex");
	},
	async uploadPorjectFile(file, project_id) {
		return request("/project/uploadFile", file, project_id);
	},
	async getDepartmentGroup() {
		return request("/user/get_department_group");
	},
	async getDepartsAndRolesByCompany(company_id) {
		return request("/user/get_departs_and_roles_by_company", {company_id})
	},
	async createDepartment(name) {
		return request("/user/create_department", { name });
	},
	async getCompanyMembers() {
		return request("/user/get_company_members");
	},
	async getAdminsByCompany(company_id) {
		return request("/user/get_admins_by_company", {company_id});
	},
	async checkLoginAccount(username, password) {
		return request("/user/check_login_account",{username, password});
	},
	async getProjectGroup() {
		return request("/user/get_project_group");
	},
	async getProjectsByCompany(company_id) {
		return request("/user/get_projects_by_company", {company_id});
	},
	async getProjectRolesByCompany(company_id) {
		return request("/user/get_project_roles_by_company", {company_id});
	},
	async getProOrDepMembers(isProOrDep, company_id, id){
		return request("/user/get_members", {isProOrDep, company_id, id});
	},
	async getApplyPurchaseWeb(search, field, from_time, to_time, plist, intlist, clist, tab_status, page, len){
		return request("/project/get_apply_purchase_web", {search, field, from_time, to_time, plist, intlist, clist, tab_status, page, len});
	},
	async getApplyPurchase(project_id, status, page, len){
		return request("/project/get_apply_purchase", {project_id, status, page, len});
	},
	async getApplyPurchaseCount(){
		return request("/project/get_apply_purchase_count");
	},
	async getApplyTicketMaterials(ticket_id) {
		return request("/project/get_apply_ticket_materials", { ticket_id });
	},
	async getMenuList() {
		return request("/main/get_workstage_menu");
	},
	async goUpdateSupplierBasicDetail(supplier_detail){
		return request("/main/update_supplier_basic_detail", supplier_detail, "application/json");
	},
	async getSuppliersList(page,len){
		return request("/main/get_suppliers_list", {page,len});
	},
	async getSuppliersNameList(){
		return request("/main/get_suppliers_name_list");
	},
	async getSupplierMaterialDetail(supplier_id, material_id){
		return request("/main/get_supplier_material_detail", {supplier_id, material_id});
	},
	async goSearchSupplier(supplier, page, len){
		return request("/main/go_search_supplier", {supplier, page, len});
	},
	async getMaterialList(page,len){  //分页获取
		return request("/main/get_material_list", {page, len});
	},
	async getAllMaterialList(search, page, len) {
		return request("/project/get_all_material_list", {search, page, len});
	},
	async getMaterialPurchaseRecord(search, goods_id, material_id, page,len){  //分页获取
		return request("/main/get_material_purchase_record", {search, goods_id, material_id, page, len});
	},
	async getSoleMaterialList(search, page,len){  //分页获取
		return request("/main/get_sole_material_list", {search, page, len});
	},
	async getMaterialInventory(search, page,len){  //分页获取
		return request("/main/get_material_inventory", {search, page, len});
	},
	async getMaterialDataSupplier(material_id){  //分页获取
		return request("/main/get_material_data_supplier", {material_id});
	},
	async goSearchMaterial(search, category_id, page, len){
		return request("/main/go_search_material", {search, category_id, page, len});
	},
	async getSupplierBasicDetail(supplier_id){
		return request("/main/get_supplier_basic_detail", {supplier_id});
	},
	async goAddSupplierInvoice(invoice_detail){
		return request("/main/go_add_supplier_invoice", invoice_detail, "application/json");
	},
	async getSupplierGoodsDetail(supplier_id, search, page, len){
		return request("/main/get_supplier_goods_detail", {supplier_id, search, page, len});
	},
	async getSupplierInvoiceData(supplier_id, search, page, len){
		return request("/main/get_supplier_invoice_data", {supplier_id, search, page, len});
	},
	async goSearchSupplierMaterial(supplier_id, material, page, len){
		return request("/main/go_search_supplier_material", {supplier_id, material, page, len});
	},
	async getEnquiryRecord(material_id, supplier_id, page, len){
		return request("/main/get_enquiry_record", {material_id, supplier_id, page, len});
	},
	async goSearchEnquiry(material_id, enquiry, page, len){
		return request("/main/go_search_enquiry", {material_id, enquiry, page, len});
	},
	async getMaterialCategory(material_id){
		return request("/main/get_material_category", {material_id});
	},
	async goAddMaterial(material){
		return request("/main/add_material", material, "application/json");
	},
	async goAddMaterialPurchaseRecord(record){
		return request("/main/add_material_purchase_record", record, "application/json");
	},
	async goAddSupplierMaterial(material_detail){
		return request("/main/add_supplier_material", material_detail, "application/json");
	},
	async saveEnquiryRecord(enquiry_detail){
		return request("/main/add_enquiry_record", enquiry_detail, "application/json");
	},
	async goDeleteEnquiry(enquiry_id){
		return request("/main/go_delete_enquiry", {enquiry_id});
	},
	async getTableTabs(){
		return request("/main/get_table_tabs");
	},
	async updateTicketMaterial(form) {
		return request("/project/update_ticket_material", form, "application/json");
	},
	async updateMaterialFixedAssets(material_id, is_fixed_assets){
		return request("/project/update_material_fixed_assets", {material_id, is_fixed_assets});
	},
	async updateTicketMaterialFixedAssets(ticket_goods_id, is_fixed_assets){
		return request("/project/update_ticket_material_fixed_assets", {ticket_goods_id, is_fixed_assets});
	},
	async comfirmUpload(bank_detail) {
		return request("/project/upload_bank_receipt", bank_detail, "application/json");
	},
    async handleMaterialTicket(param) {
		return request("/project/handle_material_ticket", param, "application/json");
	},
	async getPurchaseFinishRecord(search, page, len) {
		return request("/project/get_purchase_finish_record", {search, page, len});
	},
    async deleteTicketMaterial(id) {
		return request("/project/delete_ticket_material", {id});
	},
    async resumeTicketMaterial(id) {
		return request("/project/resume_ticket_material", {id});
	},
    async submitTicketCollectDone(form) {
		return request("/project/submit_ticket_collect_done", form, "application/json");
	},
	async getFinancialPayment() {
		return request("/project/get_financial_payment");
	},
	async confirmPayment(id, pay_all) {
		return request("/project/confirm_payment", { id, pay_all });
	},
	async submitTicketOperation(ids) {
		return request("/project/submit_ticket_operation", {ids});
	},
	async getInstorageRecord(search, page, len, begin, end){
		return request("/project/get_instorage_record", {search, page, len, begin, end});
	},
	async getInstorageSummary(search, page, len, begin, end, month, select){
		return request("/project/get_instorage_summary", {search, page, len, begin, end, month, select});
	},
	async getOutStorageRecord(search, page, len, begin, end){
		return request("/project/get_out_storage_record", {search, page, len, begin, end});
	},
	async getOutStorageSummary(search, page, len, begin, end, month, select){
		return request("/project/get_out_storage_summary", {search, page, len, begin, end, month, select});
	},
	async goExportCsv(search, begin, end, month, select, type){
		return request("/project/export_csv", {search, begin, end, month, select, type});
	},
	async getProjectList(){
		return request("/project/get_projects");
	},
	async searchProjectList(search){
		return request("/project/search_projects", {search});
	},
	async getSelectProjectMembers(project_id, search){
		return request("/user/get_select_project_member", {project_id, search});
	},
	async getProjectAllMembers(project_id){
		return request("/user/get_project_member", {project_id});
	},
	async getWithoutMemberProjects(user_id){
		return request("/user/get_without_member_projects", {user_id});
	},
	async project(id) {
		return request("/project/project", {id})
	},
	async getDocByProjectId(project_id) {
		return request("/project/get_doc_by_projectId", {project_id})
	},
	async deleteProjectDoc(doc_id) {
		return request("/project/delete_project_doc", {doc_id})
	},
	async getProjectMembers(project_id, dep_id, search, page, len){
		return request("/project/get_project_members", {project_id, dep_id, search, page, len});
	},
	async getPersonalDetail(person_id){
		return request("/project/get_personal_detail", {person_id});
	},
	async getCapitalAssets(project_id, search, page, len) {
		return request("/main/capital_assets", {project_id, search, page, len});
	},
	async getCategories(){
		return request("/project/get_categories");
	},
	async getCompanyMaterialsList(){
		return request("/main/get_company_materials_list");
	},
	async getMaterialDetail(material_id){
		return request("/project/get_material_detail", {material_id});
	},
	async getMaterialTableData(material_id, table_id, page, len){
		return request("/project/get_material_table_data", {material_id, table_id, page, len});
	},
	async getCostPlan(search, page, len){
		return request("/project/get_cost_plan", {search, page, len});
	},
	async getCompanyMember(){
		return request("/user/get_group_member2");
	},
	async goSearchMemberDetail(search){
		return request("/user/go_search_member_detail", {search});
	},
	async goAddSettlement(settle){
		return request("/project/go_add_settlement", settle, "application/json");
	},
	async getSettlementRecord(search, page, len){
		return request("/project/get_settlement_record", {search, page, len});
	},
	async getSettlementDetail(settle_id){
		return request("/project/get_settlement_detail", {settle_id});
	},
	async goAddTeamContract(contract){
		return request("/project/go_add_team_contract", contract, "application/json");
	},
	async getTeamContractRecord(search, page, len){
		return request("/project/get_team_contract_record", {search, page, len});
	},
	async getTeamContractDetail(team_id){
		return request("/project/get_team_contract_detail", {team_id});
	},
	async getAnnotationList(detail_id, type){
		return request("/project/get_annotation_list", {detail_id, type});
	},
	async saveNote(form){
		return request("/project/save_note", form, "application/json");
	},
	async updateNoteFile(id, key, data){
		return request("/project/update_note_file", {id, key, data});
	},
	async deleteNoteRecord(id, uid){
		return request("/project/delete_note", {id, uid});
	},
	async goAddRemetering(remetering){
		return request("/project/go_add_remetering", remetering, "application/json");
	},
	async getRemeteringRecord(search, page, len){
		return request("/project/get_remetering_record", {search, page, len});
	},
	async getRemeteringDetail(remet_id){
		return request("/project/get_remetering_detail", {remet_id});
	},
	async goAddPriceAdjust(adjust){
		return request("/project/go_add_price_adjust", adjust, "application/json");
	},
	async getPriceAdjustRecord(search, page, len){
		return request("/project/get_price_adjust_record", {search, page, len});
	},
	async getPriceAdjustDetail(adjust_id){
		return request("/project/get_price_adjust_detail", {adjust_id});
	},
	async getTransportDetail(trans_id){
		return request("/project/get_transport_detail", {trans_id});
	},
	async getTransportApplyRecord(search, page, len){
		return request("/project/get_transport_apply_record", {search, page, len});
	},
	async getTransportApprovalDetail(apply_id, from_project_id, to_project_id){
		return request("/project/get_transport_approval_detail", {apply_id, from_project_id, to_project_id});
	},
	async goAddTransport(transport){
		return request("/project/go_add_transport", transport, "application/json");
	},
	async getTransportApprovalList(from_project_id, to_project_id){
		return request("/project/get_transport_approval_list", {from_project_id, to_project_id});
	},
	async getMachineryRentalRecord(search, item_id, page, len){
		return request("/project/get_machinery_rental_record", {search, item_id, page, len});
	},
	async getMachineryRentalDetail(trans_id){
		return request("/project/get_machinery_rental_detail", {trans_id});
	},
	async getMachineryRentalApplyRecord(search, page, len){
		return request("/project/get_machinery_rental_apply_record", {search, page, len});
	},
	async goAddMachineryRental(machineryRental){
		return request("/project/go_add_machinery_rental", machineryRental, "application/json");
	},
	async goAddScrapMaterial(name, remark){
		return request("/project/go_add_scrap_material", {name, remark});
	},
	async getScrapMaterialList(){
		return request("/project/get_scrap_material_list");
	},
	async getProjectMaterialList(project_id){
		return request("/project/get_project_material_list", {project_id});
	},
	async getProjectFeeRecord(search, page, len){
		return request("/project/get_project_fee_record", {search, page, len});
	},
	async getProjectFeeDetail(fee_id){
		return request("/project/get_project_fee_detail", {fee_id});
	},
	async goAddProjectFee(project){
		return request("/project/go_add_project_fee", project, "application/json");
	},
	async getSchemeRecord(search, field, plist,clist, intlist, from, to, page, len, menu_id){
		return request("/project/get_scheme_record", {search, field, plist,clist, intlist, from, to, page, len, menu_id});
	},
	// async getSchemeRecord(search, item_id){
	// 	return request("/project/get_scheme_record", {search, item_id});
	// },
	async getSchemeDetail(sch_id){
		return request("/project/get_scheme_detail", {sch_id});
	},
	async goAddScheme(scheme){
		return request("/project/go_add_scheme", scheme, "application/json");
	},
	async getScrapSaleApplyRecord(search, select_item, page, len){
		return request("/project/get_scrap_sale_apply_record", {search, select_item, page, len});
	},
	async getScrapSaleRecord(search, plist, page, len, begin_date, end_date){
		return request("/project/get_scrap_sale_record", {search, plist, page, len, begin_date, end_date});
	},
	async getScrapSaleSummary(search, plist, page, len, begin, end, month, select){
		return request("/project/get_scrap_sale_summary", {search, plist, page, len, begin, end, month, select});
	},
	async getScrapSaleDetail(scrap_id){
		return request("/project/get_scrap_sale_detail", {scrap_id});
	},
	async goAddScrapSale(scrap){
		return request("/project/go_add_scrap_sale", scrap, "application/json");
	},
	async deleteScrapSaleRecord(key){
		return request("/project/delete_scrap_sale_record", {key});
	},
	async getProceedsRecord(type_id, search, page, len){
		return request("/project/get_proceeds_record", {type_id, search, page, len});
	},
	async getProceedsDetail(pro_id){
		return request("/project/get_proceeds_detail", {pro_id});
	},
	async goAddProceeds(proceeds){
		return request("/project/go_add_proceeds", proceeds, "application/json");
	},
	async getVisaRecord(search, page, len){
		return request("/project/get_visa_record", {search, page, len});
	},
	async getVisaDetail(visa_id){
		return request("/project/get_visa_detail", {visa_id});
	},
	async goAddVisa(visa){
		return request("/project/go_add_visa", visa, "application/json");
	},
	async getFinanceTableType(){
		return request("/project/get_finance_table_type");
	},
	// async getFinanceTypeData(type_id, search, page, len, month){
	// 	return request("/project/get_finance_type_data", {type_id,search, page, len,month});
	// },
	async getFenBaoImg(fenbao_id){
		return request("/project/get_fenBao_img", {fenbao_id});
	},
	async createContractTemplate(body) {
		return request("/project/create_contract_template", body, "application/json")
	},
	async getContractTemplates(type) {
		return request("/project/get_contract_templates", {type})
	},
	async saveContract(params) {
		return request("/project/save_contract", params)
	},
	async deleteContract(id, message) {
		return request("/project/delete_contract", {id, message})
	},
	async getContracts(project_id, page, page_len, type) {
		return request("/project/get_contracts", {project_id, page, page_len, type})
	},
	async getPendingContracts(page, page_len, type) {
		return request("/project/get_pending_contracts", {page, page_len, type})
	},
	async getContactDetails(id) {
		return request("/project/get_contact_details", {id})
	},
	async getMyContactDetails(id) {
		return request("/project/get_my_contact_details", {id})
	},
	async getContractMarks(id) {
		return request("/project/get_contract_marks", {id})
	},
	async markContract(id, remark) {
		return request("/project/mark_contract", {id, remark})
	},
	async getCompanyStaff() {
		return request("/user/get_company_staff")
	},
	async getFavoriteGroup(){
		return request("/user/get_favorite_group");
	},
	async getUserGroup() {
		return request("/user/get_user_group");
	},
	async createProfile(form) {
		return request("/user/create_user_profile", form, "application/json");
	},
	async getAdminFlowApply(event_type) {
		return request("/user/get_admin_flow_apply", { event_type });
	},
	async getSuccessFlowApplyRecord(search, page, len, event_type) {
		return request("/project/get_success_flow_apply", { search, page, len, event_type });
	},
	async getAdminFlowApplyRecord(search, form, page, len, menu_id, event_type) {
		return request("/project/get_admin_flow_apply_record", { search, form, page, len, menu_id, event_type });
	},
	async getFlowApply(event_type) {
		return request("/user/get_flow_apply", { event_type });
	},
	async getFlowApplyBySearch2(event_type, search, page, len) {
		return request("/project/get_flow_apply_by_search", { event_type, search, page, len })
	},
	async getFlowApplyBySearch(event_type, search, form, page, len, menu_id) {
		return request("/project/get_flow_apply_by_search", { event_type, search, form, page, len, menu_id })
	},
	async getFlowApplyById(record_id) {
		return request("/project/get_apply_record_by_id", { record_id });
	},
	async getFlowSteps(id) {
		return request("/user/get_flow_steps", { id });
	},
	async deleteAdmin(uid) {
		return request("/user/delete_admin", { uid });
	},
	async getUserCerts(uid) {
		return request("/user/get_user_certs", { uid });
	},
	async removeUserCert(cid) {
		return request("/user/remove_user_cert", { cid });
	},
	async addUserCert(form) {
		return request("/user/add_user_cert", form, "application/json");
	},
	async createCourt(form) {
		return request("/user/create_court", form);
	},
	async getCourts(page, len) {
		return request("/user/get_courts", {page, len});
	},
	async getCourt(id) {
		return request("/user/get_court", {id});
	},
	async saveCourtInfo(key, value, id) {
		return request("/user/save_court_info", {key, value, id});
	},
	async createNewProject(form) {
		return request("/project/create_new_project", form, "application/json");
	},
	async getProjectStaff(project_id) {
		return request("/project/get_project_staff", { project_id });
	},
	async goAddFenBaoRecord(newRecord) {
		return request("/project/go_add_finance_fenbao_record",newRecord,"application/json");
	},
	async getContractList(project_id) {
		return request("/project/get_contract_list", {project_id});
	},
	async updateProbationary(uid, is_probationary, probationary_date) {
		return request("/project/update_probationary", {uid, is_probationary, probationary_date});
	},
	async updateSalary(uid, salary) {
		return request("/project/update_salary", {uid, salary});
	},
	async getRoles() {
		return request("/project/get_roles");
	},
	async getTransportData(begin_date, end_date, search, page, len) {
		return request("/project/get_transport_data", {begin_date, end_date, search, page, len});
	},
	async getTransportSummary(select, begin, end, month, search, page, len){
		return request("/project/get_transport_summary", {select, begin, end, month, search, page, len});
	},
	async getTransportMonthData(out_project_id, in_project_id, search, page, len, month) {
		return request("/project/get_transport_month_data", {out_project_id, in_project_id, search, page, len, month});
	},
	async goAddMaterialScrap(newRecord) {
		return request("/project/go_add_material_scrap",newRecord,"application/json");
	},
	async getMaterialScrapRecord(search, page, len, begin, end) {
		return request("/project/get_material_scrap_record", {search, page, len, begin, end});
	},
	async getMaterialScrapSummary(search, page, len, begin, end, month, select) {
		return request("/project/get_material_scrap_summary", {search, page, len, begin, end, month, select});
	},
	async getMaterialScrapApplyRecord(search, item, page, len) {
		return request("/project/get_material_scrap_apply_record", {search, item, page, len});
	},
	async getPrivileges() {
		return request("/project/get_privileges");
	},
	async changeUserAuth(role, data) {
		return request("/project/update_user_auth", {role, data});
	},
	async addRoleData(name, dep_id, persons, data) {
		return request("/project/add_role_data", {name, dep_id, persons, data});
	},
	async addRole(name, dep_id, data) {
		return request("/project/add_role", {name, dep_id, data});
	},
	async getAdminByRole() {
		return request("/main/get_admin_by_role");
	},
	async getContractFlow(id) {
		return request("/main/get_contract_flow", {id});
	},
	async goAddPersonnelTransfer(newApply) {
		return request("/project/go_add_personnel_transfer",newApply,"application/json");
	},
	async getFinanceExpendTable(type_id) {
		return request("/project/get_finance_expend_table", {type_id});
	},
	async getFinanceExpendData(project_id, type_id, search, page, len) {
		return request("/project/get_finance_expend_data", {project_id, type_id, search, page, len});
	},
	async updateProjectFeeFixedAssets(id, condition) {
		return request("/project/update_project_fee_fixed_assets", {id, condition});
	},
	async goAddBatchPay(newBatch) {
		return request("/project/go_add_batch_pay",newBatch,"application/json");
	},
	async goAddManpower(newManpower) {
		return request("/project/go_add_manpower",newManpower,"application/json");
	},
	async getManpowerRecord(search, page, len) {
		return request("/project/get_manpower_record", {search, page, len});
	},
	async goAddOwersConfirm(newOwersConfirm) {
		return request("/project/go_add_owers_confirm",newOwersConfirm,"application/json");
	},
	async getOwersConfirmRecord(search, page, len) {
		return request("/project/get_owers_confirm_record", {search, page, len});
	},
	async deletePersonnalTransfer(id, flow_apply_id){
		return request("/project/delete_personnal_transfer", {id,flow_apply_id});
	},
	async acceptContract(id, message) {
		return request("/main/accept_contract", {id, message});
	},
	async rejectContract(id, message, type) {
		return request("/main/reject_contract", {id, message, type});
	},
	async addAuditContractPerson(req) {
		return request("/project/add_contract_audit_person", {req});
	},
	async saveCase(form) {
		return request("/project/save_case", form, "application/json");
	},
	async finishCase(id) {
		return request("/project/finish_case", {id});
	},
	async deleteCase(id) {
		return request("/project/delete_case", {id});
	},
	async getCaseList(field, plist, state, search, page, len) {
		return request("/project/get_case_list", { field, plist, state, search, page, len });
	},
	async saveLawLetter(form) {
		return request("/project/save_law_letter", form, "application/json");
	},
	async deleteLawLetter(id) {
		return request("/project/delete_law_letter", {id});
	},
	async getLawLetter(project_id, search, page, len) {
		return request("/project/get_law_letter", { project_id, search, page, len });
	},
	async saveLawLabor(form) {
		return request("/project/save_law_labor", form, "application/json");
	},
	async getLawLabor(field, plist, state, search, page, len) {
		return request("/project/get_law_labor", { field, plist, state, search, page, len});
	},
	async finishLawLabor(id) {
		return request("/project/finish_law_labor", { id });
	},
	async deleteLawLabor(id) {
		return request("/project/delete_law_labor", { id });
	},
	async saveWorkInjury(form) {
		return request("/project/save_work_injury", form, "application/json");
	},
	async getWorkInjury(field, plist, state, search, page, len) {
		return request("/project/get_work_injury", { field, plist, state, search, page, len});
	},
	async getPurchaseHistory(project_id, search, start_date, end_date, page, len) {
		return request("/project/get_purchase_history", { project_id, search, start_date, end_date, page, len });
	},
	async goAddSubpackage(newSubpackage) {
		return request("/project/go_add_subpackage",newSubpackage,"application/json");
	},
	async getSubpackageRecord(search, page, len) {
		return request("/project/get_subpackage_record", {search, page, len});
	},
	async getFinanceSettleData(select_project, select_type, chooseMonth, search, page, len){
		return request("/project/get_finance_settle_data", {select_project, select_type, chooseMonth, search, page, len});
	},
	async goUploadBankOrder(bank_detail){
		return request("/project/go_upload_bank_order", bank_detail, "application/json");
	},
	async getFinanceFormData(menu_id, search, page, len) {
		return request("/project/get_finance_form_data", {menu_id, search, page, len});
	},
	async getFinanceProjectDetailData(menu_id, project_id, search, page, len) {
		return request("/project/get_finance_project_detail_data", {menu_id, project_id, search, page, len});
	},
	async getMaterialMonthInventory(search, page, len, month) {
		return request("/project/get_material_month_inventory", {search, page, len, month});
	},
	async getBuildings(project_id) {
		return request("/project/get_buildings", {project_id})
	},
	async copyBuilding(building_id, name) {
		return request("/project/copy_building", {building_id, name})
	},
	async cancelBuilding(building_id) {
		return request("/project/cancel_building", {building_id})
	},
	async getBuildingInfo(id) {
		return request("/project/get_building_info", {id})
	},
	async getProTime(type,project_id) {
		return request("/project/get_pro_time",{type,project_id})
	},
	async updateBuildingFloorCount(id, floor) {
		return request("/project/update_building_floor_count", {id, floor})
	},
	async updateBuildingTitle(id, title) {
		return request("/project/update_building_title", {id, title})
	},
	async updateBuildingStartTime(building_id, start_date, period, id) {
		return request("/project/update_building_start_time", {building_id, start_date, period, id})
	},
	async saveProjectBuildingFlow(building_id, start_date, period, name) {
		return request("/project/save_project_building_flow", {building_id, start_date, period, name})
	},
	async updateFlowStartTime(building_id, start_date, period, id) {
		return request("/project/update_flow_start_time", {building_id, start_date, period, id})
	},
	async withdrawFlow(flow_id) {
		return request("/project/withdraw_flow", {flow_id})
	},
	async relaunchFlow(flow_id) {
		return request("/project/relaunch_flow", {flow_id})
	},
	async deleteFlow(id) {
		return request("/project/delete_flow", {id})
	},
	async getPurchaseSupplierOfferLink(key) {
		return request("/project/get_purchase_supplier_offer_link", {key})
	},
	async deleteTicket(flow_id, ticket_id) {
		return request("/project/delete_ticket", {flow_id, ticket_id})
	},
	async addMaterialSupplierOffer(form) {
		return request("/main/add_material_supplier_offer", form, "application/json")
	},
	async createSupplierOfferLink(offer_data){
		return request("/project/create_supplier_offer_link", offer_data, "application/json");
	},
	async getPurchaseSupplierOfferLinkList(purchase_goods_id){
		return request("/project/get_purchase_supplier_offer_link_list", {purchase_goods_id});
	},
	async getSupplierOfferLinkList(project_id, search, page, len){
		return request("/project/get_supplier_offer_link_list", {project_id, search, page, len});
	},
	async checkSupplierOfferUnique(material_id, supplier_id, unique){
		return request("/project/check_supplier_offer_unique", {material_id, supplier_id, unique});
	},
	async getMaterialSupplierOfferList(material_id, search, page, len){
		return request("/project/get_material_supplier_offer_list", {material_id, search, page, len});
	},
	async getMaterialSupplierPriceList(material_id, search, page, len){
		return request("/project/get_material_supplier_price_list", {material_id, search, page, len});
	},
	async saveFlowData(form){
		return request("/project/save_flow_data", form, "application/json");
	},
	async saveWaitingFlowData(form){
		return request("/project/save_waiting_flow_data", form, "application/json");
	},
	async getWaitingFlowData(event_type){
		return request("/project/get_waiting_flow_apply", {event_type});
	},
	async goDeleteWaitingDetail(flow_id){
		return request("/project/go_delete_waiting_flow", {flow_id});
	},
	async saveStampApply(form){
		return request("/project/save_stamp_apply", form, "application/json");
	},
	async saveCancelStampApply(form){
		return request("/project/save_cancel_stamp_apply", form, "application/json");
	},
	async getCancelFlowApplyDataByFlowId(fid){
		return request("/project/get_cancel_flow_apply_data_by_flowId", {fid});
	},
	async getStampApplyRecord(search, field, plist, olist, stampslist, clist, mlist, importlist, intlist, tlist, create_from, create_to, modify_from, modify_to, page, page_len, menu_id){
		return request("/project/get_stamp_apply_record", {search, field, plist, olist, stampslist, clist, mlist, importlist, intlist, tlist, create_from, create_to, modify_from, modify_to, page, page_len, menu_id});
	},
	// async getStampApplyRecord(search, item_id) {
	// 	return request("/project/get_stamp_apply_record", {search, item_id})
	// },
	async getStampApplyRecordById(record_id){
		return request("/project/get_stamp_apply_record_by_id", {record_id});
	},
	async getStampFlowIdByCancelId(cancel_id){
		return request("/project/get_stamp_flowId_by_cancelId", {cancel_id});
	},
	async saveBuildingName(id,project_id, index, name) {
		return request("/project/save_building_name", {id,project_id, index, name})
	},
	async uploadPaymentExcel(file) {
		return request("/project/upload_payment_excel", file)
	},
	async uploadCompanyDocs(file) {
		return request("/project/upload_company_docs", file)
	},
	async getMonthlyAttendanceStatistics(month) {
		return request("/project/get_monthly_attendance_statistics", {month})
	},
	async getPersonalMonthlyAttendanceStatistics(uid, month) {
		return request("/project/get_personal_monthly_attendance_statistics", {uid, month})
	},
	async getHireFlow(dep_id, type, params) {
		if (params != null) {
			params.type = type;
			params.dep_id = dep_id;
		} else {
			params = {dep_id, type};
		}
		return request("/project/get_hire_flow", params)
	},
	async getDepCompanyProjectFlow(dep_id, type, params) {
		if (params != null) {
			params.type = type;
			params.dep_id = dep_id;
		} else {
			params = {dep_id, type};
		}
		return request("/project/get_dep_company_project_flow", params)
	},
	async getCompanyProjectFlow(type, params) {
		if (params != null) {
			params.type = type;
		} else {
			params = {type};
		}
		return request("/project/get_company_project_flow", params)
	},
	async getDimissionProjectFlow(uid, params) {
		if (params != null) {
			params.uid = uid;
		} else {
			params = {uid};
		}
		return request("/project/get_dimission_project_flow", params)
	},
	async getDailyAttendanceStatistics() {
		return request("/project/get_daily_attendanc_statistics")
	},
	async getDailyContractApprove() {
		return request("/project/get_daily_contract_approve")
	},
	async getDailyProjectSchedule() {
		return request("/project/get_daily_project_schedule")
	},
	async getLoginUserDetail() {
		return request("/project/get_login_user_detail")
	},
	async getDailyStorageRecord() {
		return request("/project/get_daily_storage_record")
	},
	async getDailyMiniMaterialInventory() {
		return request("/project/get_daily_mini_material_inventory")
	},
	async getDailyContractData(start_time, end_time) {
		return request("/project/get_daily_contract_data", {start_time, end_time})
	},
	async getApprovalDetail(apply_id) {
		return request("/project/get_approval_detail", {apply_id})
	},
	async getXiaojiaApprovalDetail(apply_id) {
		return request("/project/get_xiaojia_approval_detail", {apply_id})
	},
	async getPurchaseApprovalDetail(apply_id) {
		return request("/project/get_purchase_approval_detail", {apply_id})
	},
	async getPurchaseFlowApplyById(record_id) {
		return request("/project/get_purchase_apply_record_by_id", {record_id})
	},
	async getStampPersonDetail(apply_id) {
		return request("/project/get_stamp_person_detail", {apply_id})
	},
	async addAuditPerson(req) {
		return request("/project/add_audit_person", req, "application/json");
	},
	async acceptFlow(fid, message, amount) {
		return request("/project/accept_flow", {fid, message, amount})
	},
	async rejectFlow(fid, message) {
		return request("/project/reject_flow", {fid, message})
	},
	async acceptStampFlow(fid, message) {
		return request("/project/accept_stamp_flow", {fid, message})
	},
	async rejectStampFlow(fid, message, type) {
		return request("/project/reject_stamp_flow", {fid, message, type})
	},
	async checkStampApproval(fid) {
		return request("/project/check_stamp_approval", {fid})
	},
	
	

	async getDepMasterByRoles(roles) {
		return request("/project/get_dep_master_by_roles", {roles})
	},
	async getSubCompanies() {
		return request("/project/get_sub_companies")
	},
	async searchSupplier(text) {
		return request("/project/search_supplier", {text})
	},
	async getPersonInfoByType(id, type, project_id) {
		return request("/project/get_person_info_by_type", {id, type, project_id})
	},
	async getJingliPersonInfoByType(id, type, project_id) {
		return request("/project/get_jingli_person_info_by_type", {id, type, project_id})
	},
	async getPersonInfoByType2(id, dep_id, type, project_id) {
		return request("/project/get_person_info_by_type2", {id, dep_id, type, project_id})
	},
	async getContractPersonInfo(id) {
		return request("/project/get_contact_person_info", {id})
	},
	async withdrawContract(contact_id) {
		return request("/project/withdraw_contract", {contact_id})
	},
	async relaunchContract(contact_id) {
		return request("/project/relaunch_contract", {contact_id})
	},
	async queryContracts(key,value,page, page_len, menu_id, type) {
		return request("/project/query_contracts", {key, value,page, page_len, menu_id, type})
	},
	async confirmNormalStamp(data) {
		return request("/project/confirm_normal_stamp", data, "application/json");
	},
	async withdrawStamp(stamp_id) {
		return request("/project/withdraw_stamp", {stamp_id})
	},
	async relaunchStamp(stamp_id) {
		return request("/project/relaunch_stamp", {stamp_id})
	},
	async deleteStamp(stamp_id) {
		return request("/project/delete_stamp", {stamp_id})
	},
	async confirmStamp(data) {
		return request("/project/confirm_stamp", data, "application/json");
	},
	async archiveStamp(stamp_id) {
		return request("/project/archive_stamp", {stamp_id});
	},
	async queryContactByTime(key,value,from, to, page, page_len, menu_id, type) {
		return request("/project/query_contact_by_time", {key,value,from, to, page, page_len, menu_id, type})
	},
	async queryContactByStatus(key,value,list, page, page_len, menu_id, type) {
		return request("/project/query_contact_by_status", {key,value,list, page, page_len, menu_id, type})
	},
	async queryContactByApproval(key,value,list, search, page, page_len, menu_id, type) {
		return request("/project/query_contact_by_approval", {key,value,list, search, page, page_len, menu_id, type})
	},
	async queryContract(search_key, field, from, to, accept_from, accept_to, plist, slist, ulist, alist, clist, tlist, cslist, page, page_len, menu_id, template_id,  type) {
		return request("/project/query_contract", {search_key, field, from, to, accept_from, accept_to, plist, slist, ulist, alist, clist, tlist, cslist, page, page_len, menu_id, template_id, type})
	},
	async sealContract(contract_id) {
		return request("/project/seal_contract", {contract_id})
	},
	async archiveContract(contract_id) {
		return request("/project/archive_contract", {contract_id})
	},
	async getContractsCount(type) {
		return request("/project/get_contract_count", {type})
	},
	async getPurchaseApplyRecord(search, item_id) { 
		return request("/project/get_purchase_apply_record", {search, item_id})
	},
	// async deletePurchaseFlowApply(search, item_id) {
	// 	return request("/project/delete_purchase_flow_apply", {search, item_id})
	// },
	async getContractDrafts(type) {
		return request("/project/get_contract_draft", {type})
	},
	async deleteContractDraft(id) {
		return request("/project/delete_contract_draft", {id})
	},
	async getPurchaseDetail(apply_id) {
		return request("/project/get_purchase_apply_detail", {apply_id})
	},
	async addClient(data) {
		return request("/project/add_client", data, "application/json")
	},
	async getClientsList(search, page, len) {
		return request("/project/get_clients_list", {search, page, len})
	},
	async getClients() {
		return request("/project/get_clients")
	},
	async deleteMaterial(id) {
		return request("/project/delete_material", {id})
	},
	async getNotificationList(status, item_id, search, page, len) {
		return request("/project/get_notification_list", { status, item_id, search, page, len })
	},
	async changeReadStatus(item_id) {
		return request("/project/update_notification_status", { item_id })
	},
	async uploadConfirmContractFile(contract_id, doc_data) {
		return request("/project/upload_confirm_contract_file", {contract_id, doc_data})
	},
	async getPendingAndDoneApply(key, search_key, field, sList, page, page_len) {
		return request("/project/get_pending_and_done_apply", {key, search_key, field, sList, page, page_len})
	},
	async getAllNotificationList(key, search_key, field, sList, page, page_len) {
		return request("/project/get_all_notification_list", {key, search_key, field, sList, page, page_len})
	},
	async getUnsettleAndUnReadCount() {
		return request("/project/get_unsettle_and_unRead_count")
	},
	async getAdminDepartID() {
		return request("/project/get_admin_depart_id")
	},
	async getAttendanceApplyRecord(search, creator, approvor, statusList, typeList, begin_time, end_time, page, page_len, menu_id) {
		return request("/project/get_attendance_apply_record", {search, creator, approvor, statusList, typeList, begin_time, end_time, page, page_len, menu_id})
	},
	async exportSheet(data, field_type, search_key, field, from, to, accept_from, accept_to, plist, slist, alist, menu_id, type) {
		return request("/export/contract", {data, field_type, search_key, field, from, to, accept_from, accept_to, plist, slist, alist, menu_id, type})
	},
	async uploadCompanyDocumnets(title, data, all_read, reader) {
		return request("/project/upload_company_documnets", {title, data, all_read, reader});
	},
	async updateCompanyDocuments(id, data) {
		return request("/project/update_company_documnets", {id, data});
	},
	async getCompanyDocuments(search) {
		return request("/project/get_company_documents", {search});
	},
	async getServeFeeSummary(year, search, page, len){
		return request("/project/get_serve_fee_summary", {year, search, page, len});
	},
	async getProjectServeFeeDetail(project_id, search, from, end, page, len){
		return request("/project/get_project_serve_fee_detail", {project_id, search, from, end, page, len});
	},
	async getServeFeeApplyRecord(search, select_item, page, len){
		return request("/project/get_serve_fee_apply_record", {search, select_item, page, len});
	},
	async deleteFlowApplyRecord(fid){
		return request("/project/delete_flow_apply_record", {fid});
	},
	async addFavorite(data){
		return request("/project/add_favorite", {data});
	},
	async getQingjiaFlowApply(){
		return request("/project/get_qingjia_flow_apply");
	},
	async getJiabanFlowApply() {
		return request("/project/get_jiaban_flow_apply");
	},
	async getApplyMinutes(fid) {
		return request("/project/get_tiaoxiu_apply__minutes", {fid})
	},
	async addAttachmentReadRecord(fid, type, url) {
		return request("/project/add_attachment_read_record", {fid, type, url})
	},
	async getPersonalBukaTime(month) {
		return request("/project/get_personal_buka_time", {month})
	},
	async importPersonnelSheet(file) {
		return upload("/project/import_personnel_table", file)
	},
	async getCompanyRoleAndDepartData() {
		return request("/project/get_company_role_and_depart_data")
	},
	async getSealTypeList() {
		return request("/project/get_seal_type_list")
	},
	async getStandardFlowApply(search, page, len, menu_id, event_type, auth_c) {
		return request("/project/get_standard_flow_apply", { search, page, len, menu_id, event_type, auth_c });
	},
	async updatePhoneManage(form) {
		return request("/project/update_phone_manage", {form});
	},
	async getDepartFlowPerson() {
		return request("/project/get_depart_flow_person");
	},
	async getStampApplyType() {
		return request("/project/get_stamp_apply_type");
	},
	async addReadCompanyDocRecord(doc_id) {
		return request("/project/add_read_company_doc_record", {doc_id})
	},
	async getTemplateList(field, dlist, tlist, search, type) {
		return request("/project/get_template_list", {field, dlist, tlist, search, type})
	},
	async getFlows() {
		return request("/project/get_flows")
	},
	async createOneFlows(type, uid) {
		return request("/project/create_one_flows", {type, uid})
	},
	async updateTemplate(form) {
		return request("/project/update_template", form, "application/json")
	},
	async getSupplierDetail(supplier_id) {
		return request("/main/get_supplier_detail", {supplier_id})
	},
	async getTemplateEditLog(id, type) {
		return request("/project/get_template_edit_log", {id, type})
	},
	async getTemplateType(type) {
		return request("/project/get_template_type", {type})
	},
	async getFeetypes() {
		return request("/project/get_fee_types")
	},
	async getTemplateDepartGroup() {
		return request("/project/get_template_depart_group")
	},
	async getCompanyTimeSet() {
		return request("/project/get_company_time_set")
	},
	async getWorks(project_id) {
		return request("/project/get_works", {project_id})
	},
	async getStampFlowDetail(search) {
		return request("/project/get_stamp_flow_detail", { search })
	},
	async uploadConfirmStampFile(stamp_id, doc_data) {
		return request("/project/upload_confirm_stamp_file", {stamp_id, doc_data})
	},
	async getPayData(search) {
		return request("/project/get_pay_data", { search })
	},
	async getMachineList() {
		return request("/project/get_machine_list")
	},
	async getMachineCompanyList() {
		return request("/project/get_machine_company_list")
	},
	async createMachine(title) {
		return request("/project/create_machine", { title })
	},
	async createMachineCompany(title) {
		return request("/project/create_machine_company", { title })
	},
	async getMachineUseData(machine_id, company_id) {
		return request("/project/get_machine_use_data", { machine_id, company_id })
	},
	async createOrganize(title) {
		return request("/project/create_company_organize", { title })
	},
	async getOrganizes() {
		return request("/project/get_organizes")
	},
	async getBigMachineWork(search, form, page, len, menu_id) {
		return request("/project/get_bigmachine_work", { search, form, page, len, menu_id })
	},
	async getWorkAttachment(work_id) {
		return request("/project/get_work_attachment", { work_id })
	},
	async deleteProjectWorkFile(over_id) {
		return request("/project/delete_project_work_file", { over_id })
	},
	async addProjectWorkFile(url, pid, project_id, type) {
		return request("/project/add_project_work_file", { url, pid, project_id, type })
	},
	async getDistWork(search, form, page, len, menu_id) {
		return request("/project/get_dist_work", { search, form, page, len, menu_id })
	},
	async getDistWorkAttachment(work_id) {
		return request("/project/get_dist_work_attachment", { work_id })
	},
	async deleteDistWorkFile(over_id) {
		return request("/project/delete_dist_work_file", { over_id })
	},
	async addDistWorkFile(url, pid, project_id, type) {
		return request("/project/add_dist_work_file", { url, pid, project_id, type })
	},
	async goAddSealType(title) {
		return request("/project/go_add_sealType", { title })
	},
	async getResponsibleTeamList() {
		return request("/project/get_responsible_team_list")
	},
	async getBuildTeamList() {
		return request("/project/get_build_team_list")
	},
	async getBuildTeamListTest(project_id) {
		return request("/project/get_build_team_list_test", { project_id })
	},
	async confirmAddTeam(project_id, name, index) {
		return request("/project/add_build_team", { project_id, name, index })
	},
	




	async test() {
		return request("/project/test")
	}

	
}